import cacheService from "@/services/cache";

export const SYSTEM_TYPE = {
    TILE: 1,
    SHELF: 2,
    CADDY: 3
};
export function generatePlanoLink(plano) {
    const systemTypeId = plano && plano.template && plano.template.systemType && plano.template.systemType.id;
    const isNext = systemTypeId === SYSTEM_TYPE.SHELF || systemTypeId === SYSTEM_TYPE.CADDY;
    return isNext ? `/planonext/${plano.id}` : `/plano/${plano.id}`;
}

export function openPlano(plano) {
    cacheService.set("planoLocked", plano.isLocked);
    const planoLink = generatePlanoLink(plano);
    this.$router.push(planoLink);
    this.selectedCampaign = plano.campaign.id;
    cacheService.set("currentCampaignId", plano.campaign.id);
}



// WEBPACK FOOTER //
// ./src/utils/plano.js